import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getSurfaceBorder } from '../tokens';

export const styledMuiDivider = (
  theme: Theme,
): BackstageOverrides['MuiDivider'] => ({
  root: {
    borderColor: getSurfaceBorder(theme),
  },
});
